import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <p className="site-footer__tag">{t('footer.tagline')}</p>
      <nav className="site-footer__nav">
        <a href="/tarifs">{t('footer.pricing')}</a>
        <a href="/games?type=danger">{t('footer.games')}</a>
        <a href="/contact">{t('footer.contact')}</a>
      </nav>
      <p className="site-footer__support">
        {t('footer.support')} <a href="mailto:support@keepmygames.com">support@keepmygames.com</a>
      </p>
      <p className="site-footer__disclaimer">{t('footer.disclaimer')}</p>
      <p className="site-footer__copy">© 2026 {t('brand')}</p>
    </footer>
  );
}

export default Footer;
